module.exports = __webpack_public_path__ + "481e7748c615d4de5df53cdcb819b664.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/bristol_myers_squibb_2022_chart.png
// module id = 1642
// module chunks = 0